import { Button, Col, Form, Input, Row, Typography } from 'antd'
import React from 'react'
import { TEXT } from '../../../../layout/style'
const { Text, Title } = Typography;

export default function ForgetPasswordEmail() {
    return (
        <>

            <Text>
                Amet ullamco exercitation pariatur duis veniam enim nisi id exercitation nostrud laborum amet. <br /> Dolor voluptate commodo do dolor ad ullamco esse sint culpa consequat. Aute dolor minim irure consectetur.
            </Text>
            <br/>
            <br/>
            <Form name="basic">
                <Form.Item>
                    <Input
                        size="large"
                        placeholder="Email"
                        name={['user', 'email']}
                        label="Email"
                        rules={[
                            {
                                type: 'email',
                            },
                        ]}
                    />
                </Form.Item>
            </Form>
        </>
    )
}
